// src/components/pages/Caixa/profiles/profileDefault.js

export const profileDefault = {
    id: 'caixa',
    labelForm: 'Caixa',
    defaultKey: 'caixa',
    tabs: {
        caixa: { enabled: true },
        lancamentos: { enabled: true },
    },
    // “UI contracts” por aba (labels/show/readonly/disabled etc.)
    uiTabs: {
        caixa: {
            titles: { grid: 'Cabeçalho do Caixa' },
            labels: {
                grid: 'Gerenciamento do caixa',
            },
            show: {
                //1ª div cabeçalho
                empresa: true,
                compra: true,
                venda: true,
                locavel: true,
                industria: true,
                servico: true,

                ncm: true,
                fabricante: true,

                flagsProduto: true, // industria/materiaPrima/bobina etc
            },
            readonly: {},
            disabled: {},
        },
        lancamentos: {
            titles: { grid: 'Gerenciamento de Lançamentos no Caixa' },
            labels: {
                grid: 'Lançamentos no caixa',
            },
            show: {},
        },
        imagens: {
            show: {
                upload: true,
                galeria: true,
            },
        },
    },
};
